module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/chocolate_d72641.jpg";